import moment from 'moment';
import { useOrderStore } from 'store/orderStore';
import _ from 'lodash';
import {
  AdType,
  CreativeDeliverType,
  DeliverType,
  RtbCampaignPlanType,
  RTBCAMPAIGN_DEFAULT_AGE_MAX,
  RTBCAMPAIGN_DEFAULT_AGE_MIN,
} from 'core/rtbCampaign/RtbCampaign';
import { BudgetType, RunningPattern } from 'core/rtbCampaign/singlePage/common';
import { L2ObjectOptimizationGoal } from 'core/l2Object/L2Object';

const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

function useCreateShop() {
  const order = useOrderStore().order;

  const useCampaignStartDay = () => {
    const now = moment().startOf('hour').add(1, 'hour');
    const orderStartDate = moment(order.startDate);
    return now.isBefore(orderStartDate) ? orderStartDate : now;
  };

  const useCampaignEndDay = () => {
    return moment.min(
      moment(order.endDate).add(1, 'days').subtract(1, 'seconds'),
      moment(useCampaignStartDay())
        .add(13, 'days')
        .endOf('day')
        .subtract(1, 'seconds'),
    );
  };

  const getDefaultCampaign = (
    startDate: moment.Moment,
    endDate: moment.Moment,
  ) => {
    const ageLimitationPresets = [
      {
        type: 'age_min',
        value: RTBCAMPAIGN_DEFAULT_AGE_MIN,
      },
      {
        type: 'age_max',
        value: RTBCAMPAIGN_DEFAULT_AGE_MAX,
      },
    ];

    const genderLimitationPresets = [];

    const limitationPreSet = {
      preferred: [...ageLimitationPresets, ...genderLimitationPresets],
    };

    const defaultCampaign = {
      basic: {
        advertiserId: order.advertiserId,
        orderId: order.id,
        adType: AdType.SHOP,
        name: order.projectName,
        budget: order.budgetBalance,
        dailyTargetBudget: order.budgetBalance,
        spents: 0,
        expectedSpent: 0,
        bidPrice: undefined,
        startDate: startDate.format(DATE_FORMAT),
        endDate: endDate.format(DATE_FORMAT),
        checkpoints: [],
        creativeDeliverType: CreativeDeliverType.OPTIMIZE,
        priceModel: RtbCampaignPlanType.RS_CPC,
        optimize: L2ObjectOptimizationGoal.CLICKS,
        deliverType: DeliverType.STANDARD,
        webBrandNo: null,
        brandName: null,
        runningPattern: RunningPattern.LIMITED,
        budgetType: BudgetType.TOTAL,
      },
      limitations: _.cloneDeep(limitationPreSet),
    };
    return defaultCampaign;
  };

  const startDate = useCampaignStartDay();
  const endDate = useCampaignEndDay();

  return { getDefaultCampaign: () => getDefaultCampaign(startDate, endDate) };
}

export default useCreateShop;
